import { useApplicationContext } from '../../utils/withApplicationContext';

export const useBuilderChatHost = () => {
  const { config } = useApplicationContext();

  return config.get<string>('builderChatHost') ?? '';
};
